module.exports = __webpack_public_path__ + "img/upgrade.cb17bb9c.png";